// extracted by mini-css-extract-plugin
export default {"mainContainer":"Indicadores_mainContainer__-bzVw","emptyCard":"Indicadores_emptyCard__veMql","track":"Indicadores_track__72FTK","title":"Indicadores_title__46MRv"};